module.exports = __webpack_public_path__ + "img/Amex.00280a7a.png";